// Available DIY guides. User picks one on first login; can change any time.
export const GUIDES = {
  corey: {
    id: 'corey',
    name: 'Corey',
    imageUrl: '/corey.png',
    title: 'Your DIY Buddy',
    tagline: "Hey — I'm Corey. Let's fix this together.",
    pronoun: 'he',
    pronoun_cap: 'He',
    posessive: 'his',
    description: 'Friendly 6\'2" guy with a warm smile',
  },
  christine: {
    id: 'christine',
    name: 'Christine',
    imageUrl: '/christine.png',
    title: 'Your DIY Buddy',
    tagline: "Hey — I'm Christine. Let's fix this together.",
    pronoun: 'she',
    pronoun_cap: 'She',
    posessive: 'her',
    description: 'Sharp, capable expert with a smile',
  },
};

export const DEFAULT_GUIDE_ID = 'corey';

export function getGuide(id) {
  return GUIDES[id] || GUIDES[DEFAULT_GUIDE_ID];
}
